module.exports = __webpack_public_path__ + "img/icon-user.f3a4f67d.svg";